import Vue from 'vue'
import Vuex from 'vuex'

import {UserModuleStore} from '@dracul/user-frontend'
import {CustomizationStore} from '@dracul/customize-frontend'
import {SettingsModuleStore} from '@dracul/settings-frontend'

import BaseModuleStore from '../modules/base/storage/BaseModuleStore'
import LayoutStore from '../layout/Store/LayoutStore'
import BarStore from '../modules/delivery/store/BarStore'
import OrderStore from '../modules/delivery/store/OrderStore'
import CategoryStore from '../modules/delivery/store/CategoryStore'
import BranchStore from '../modules/delivery/store/BranchStore'
import PromoStore from '../modules/delivery/store/PromoStore'
import PaymentModuleStore from '../modules/payment/store'

Vue.use(Vuex)

import createPersistedState from "vuex-persistedstate";

export default new Vuex.Store({
    modules: {
        layout: LayoutStore,
        base: BaseModuleStore,
        user: UserModuleStore,
        settings: SettingsModuleStore,
        //delivery: DeliveryModuleStore,
        barStore: BarStore,
        orderStore: OrderStore,
        categoryStore: CategoryStore,
        branchStore: BranchStore,
        promoStore: PromoStore,
        payment: PaymentModuleStore,
        customization: CustomizationStore
    },
    plugins: [
        createPersistedState({
            key: process.env.VUE_APP_KEY,
            paths: ['user'],
            reducer: state => (
                {
                    user: {
                        access_token: state.user.access_token,
                        refresh_token: state.user.refresh_token,
                        me: state.user.me,
                        avatarurl: state.user.avatarurl
                    },
                    customization: {
                        lightTheme: state.customization.lightTheme,
                        darkTheme: state.customization.darkTheme,
                        logo: state.customization.logo,
                        language: state.customization.language,
                        darkMode: state.customization.darkMode
                    },
                    orderStore: {
                        order: state.orderStore.order,
                        galleryView: state.orderStore.galleryView,
                        lastContact: state.orderStore.lastContact,
                        locationHistory: state.orderStore.locationHistory
                    }
                }),
                rehydrated: (storage) => {
                    if (storage?.state?.orderStore?.order) {
                        storage.commit(`setupOrder`, storage.state.orderStore.order);
                    }
                }
        })
    ]
})
